module.exports = __webpack_public_path__ + "img/0Q3A5767_L_Black_MockedUp.0bf32f06.jpg";